import { IconType } from "react-icons";
import {
  GiBiceps,
  GiLeg,
  GiAbdominalArmor,
  GiMuscleUp,
  GiMuscularTorso,
  GiArm,
} from "react-icons/gi";
import { MUSCLE_GROUPS, MuscleGroup } from "../api/types.ts";

// Map of muscle groups to their corresponding icons
const MUSCLE_GROUP_ICONS: Record<MuscleGroup, IconType> = {
  biceps: GiBiceps,
  triceps: GiBiceps,
  forearms: GiBiceps,
  pectorals: GiMuscularTorso,
  back: GiMuscularTorso,
  latissimus_dorsi: GiMuscularTorso,
  trapezius: GiMuscularTorso,
  quadriceps: GiLeg,
  hamstrings: GiLeg,
  glutes: GiLeg,
  calves: GiLeg,
  deltoids: GiArm,
  abdominals: GiAbdominalArmor,
  obliques: GiAbdominalArmor,
};

/**
 * Maps a list of muscle groups to an appropriate React icon.
 * The order of the list determines precedence - returns the icon for the first match.
 *
 * @param muscleGroups - Array of muscle group names
 * @param defaultIcon - Optional default icon to return if no match is found
 * @returns The React icon component for the first matching muscle group, or default icon
 */
export function getMuscleGroupIcon(
  muscleGroups: MuscleGroup[],
  defaultIcon: IconType = GiMuscleUp,
): IconType {
  for (const muscleGroup of muscleGroups) {
    const icon = MUSCLE_GROUP_ICONS[muscleGroup];
    if (icon) {
      return icon;
    }
  }

  return defaultIcon;
}

/**
 * Gets all standardized muscle groups
 */
export function getSupportedMuscleGroups(): readonly MuscleGroup[] {
  return MUSCLE_GROUPS.toSorted((a, b) => a.localeCompare(b));
}
